@if (visible()) {
  <ui-message severity="warn">
    <div class="flex flex-wrap items-center gap-2">
      <i class="pi pi-user-edit"></i>
      <span>{{
        'impersonation.banner' | transloco: { name: auth.displayName() }
      }}</span>
      <ui-button
        variant="secondary"
        size="sm"
        [label]="'impersonation.exit' | transloco"
        (click)="exit()"
      />
    </div>
  </ui-message>
}
